import { render, staticRenderFns } from "./Upgrades.vue?vue&type=template&id=7ae00191&"
import script from "./Upgrades.vue?vue&type=script&lang=js&"
export * from "./Upgrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports